/* eslint-disable object-curly-newline */
import update from 'immutability-helper';
import naturalCompare from 'string-natural-compare';
import { indexById } from '../indexById/indexById';
import { get as getId } from '../localId/localId';

export const ADD_LOCAL_EMPLOYEE = 'ADD_LOCAL_EMPLOYEE';
export const REMOVE_LOCAL_EMPLOYEE = 'REMOVE_LOCAL_EMPLOYEE';
export const API_LOAD_EMPLOYEES = 'API_LOAD_EMPLOYEES';
export const API_REMOVE_EMPLOYEE = 'API_REMOVE_EMPLOYEE';
export const API_CREATE_EMPLOYEE = 'API_CREATE_EMPLOYEE';
export const API_UPDATE_EMPLOYEE = 'API_UPDATE_EMPLOYEE';

const API_LOAD_EMPLOYEES_FAILED = 'API_LOAD_EMPLOYEES_FAILED';
const API_LOAD_EMPLOYEES_LOADING = 'API_LOAD_EMPLOYEES_LOADING';
const API_LOAD_EMPLOYEES_LOADED = 'API_LOAD_EMPLOYEES_LOADED';
const API_REMOVE_EMPLOYEE_FAILED = 'API_REMOVE_EMPLOYEE_FAILED';
const API_REMOVE_EMPLOYEE_LOADING = 'API_REMOVE_EMPLOYEE_LOADING';
const API_REMOVE_EMPLOYEE_SUCCESS = 'API_REMOVE_EMPLOYEE_SUCCESS';
const API_CREATE_EMPLOYEE_FAILED = 'API_CREATE_EMPLOYEE_FAILED';
const API_CREATE_EMPLOYEE_LOADING = 'API_CREATE_EMPLOYEE_LOADING';
const API_CREATE_EMPLOYEE_SUCCESS = 'API_CREATE_EMPLOYEE_SUCCESS';

const defaultState = { employees: [], loading: false };
const emptyEmployee = () => ({ id: getId(), name: '', job: '', email: '', isRemoving: false });
const mapDefaults = employee => ({ ...emptyEmployee(), ...employee });

export const reducer = (state = defaultState, { type, response, id, replaceId, resource }) => {
  switch (type) {
    case API_LOAD_EMPLOYEES_LOADED:
      return update(state, {
        loading: { $set: false },
        employees: { $set: response.map(mapDefaults) },
      });
    case API_LOAD_EMPLOYEES_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_EMPLOYEES_FAILED:
      return update(state, { loading: { $set: false } });
    case ADD_LOCAL_EMPLOYEE:
      return update(state, { employees: { $push: [emptyEmployee()] } });
    case API_REMOVE_EMPLOYEE_SUCCESS:
    case REMOVE_LOCAL_EMPLOYEE:
      return update(state, { employees: { $splice: [[indexById(id, state.employees), 1]] } });
    case API_REMOVE_EMPLOYEE_FAILED:
      return update(state, { employees: { [indexById(id, state.employees)]: { removing: { $set: false } } } });
    case API_REMOVE_EMPLOYEE_LOADING:
      return update(state, { employees: { [indexById(id, state.employees)]: { removing: { $set: true } } } });
    case API_CREATE_EMPLOYEE_FAILED:
      return update(state, { employees: { [indexById(resource.id, state.employees)]: { saving: { $set: false } } } });
    case API_CREATE_EMPLOYEE_LOADING:
      return update(state, { employees: { [indexById(resource.id, state.employees)]: { saving: { $set: true } } } });
    case API_CREATE_EMPLOYEE_SUCCESS:
      return update(state, { employees: { $splice: [[indexById(replaceId, state.employees), 1, response]] } });
    default:
      return state;
  }
};

export const employees = state => state.employees.employees.sort((a, b) => naturalCompare.caseInsensitive(a.name, b.name));
export const activeEmployees = state => state.employees.employees.filter(e => !['terminated', 'laid_off'].includes(e.role)).sort((a, b) => naturalCompare.caseInsensitive(a.name, b.name));
export const inactiveEmployees = state => state.employees.employees.filter(e => ['terminated', 'laid_off'].includes(e.role)).sort((a, b) => naturalCompare.caseInsensitive(a.name, b.name));
export const notAdmins = state => employees(state).filter(e => !['admin', 'terminated', 'laidoff'].includes(e.role));
export const loading = state => state.employees.loading;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/employees/employees.reducer.js